import { clsx } from 'clsx';

import * as styles from './SkeletonRect.css';
import { FC } from 'react';

type TDivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export interface ISkeletonRectProps extends Omit<TDivProps, 'children'> {
  height?: number | string;
  width?: number | string;
  borderRadius?: number | string;
}

export const SkeletonRect: FC<ISkeletonRectProps> = ({ height, width, borderRadius, ...passedProps }) => {
  return (
    <div
      {...passedProps}
      style={{
        ...passedProps.style,
      }}
      className={clsx(passedProps.className, styles['root'])}
    >
      <div
        className={styles['fill']}
        style={{
          height,
          width,
          borderRadius,
        }}
      />
    </div>
  );
};
